import { createSwiper, withResize } from '../../components/swiper-init.js';

export function initSwiperDemoWithResize() {
  withResize(() => createSwiper('is--demo', { initialSlide: 1 }));
}
